<template>
  <div class="residential-packages h-content mx-0 mt-[28px] min-h-[486px] w-full max-w-none px-0 py-[0px] flex justify-start items-end pt-[18px]">
    <!--sku-->
    <div ref="plansStrip" :class="plansStripClass">
      <div v-for="sku in currentSkuList" :key="sku.id || sku.desc" class="shrink-0">
        <PlanView :type="1" :sku="sku" :spu="currentSpu" @click-buy-plan="clickBuyPlan" :shrink="shrink"/>
      </div>
    </div>    
  </div>
</template>

<script>
import PlanView from "@/components/package-view/plan-view.vue"
import { getPackages } from '@/http/api/home'

export default {
  name: "residential-proxiy-view",
  components: {
    PlanView
  },
  data() {
    return {
      loading: false,
      isPlansOverflowing: false,
      skuList: [
        {
          id: "",
          desc: "",
          salePrice: 0, // 销售价格
          price: 0, // 原价格
          discountRatio: 0,  // 折扣率%
          duration: 0, // 周（7天）、月（30天）、季（90天）
          flow: 0,   // MB
          give: 0,      // 赠送流量
          popular: 0, // 热销商品
          firstOrderOnly: false,
          canBuy: true,
        },
        {
          id: "",
          desc: "",
          salePrice: 0, // 销售价格
          price: 0, // 原价格
          discountRatio: 0,  // 折扣率%
          duration: 0, // 周（7天）、月（30天）、季（90天）
          flow: 0,   // MB
          give: 0,      // 赠送流量
          popular: 0, // 热销商品
          firstOrderOnly: false,
          canBuy: true,
        },
        {
          id: "",
          desc: "",
          salePrice: 0, // 销售价格
          price: 0, // 原价格
          discountRatio: 0,  // 折扣率%
          duration: 0, // 周（7天）、月（30天）、季（90天）
          flow: 0,   // MB
          give: 0,      // 赠送流量
          popular: false, // 热销商品
          firstOrderOnly: false,
          canBuy: true,
        },
        {
          id: "",
          desc: "",
          salePrice: 0, // 销售价格
          price: 0, // 原价格
          discountRatio: 0,  // 折扣率%
          duration: 0, // 周（7天）、月（30天）、季（90天）
          flow: 0,   // MB
          give: 0,      // 赠送流量
          popular: 0, // 热销商品
          firstOrderOnly: false,
          canBuy: true,
        },
        {
          id: "",
          desc: "",
          salePrice: 0, // 销售价格
          price: 0, // 原价格
          discountRatio: 0,  // 折扣率%
          duration: 0, // 周（7天）、月（30天）、季（90天）
          flow: 0,   // MB
          give: 0,      // 赠送流量
          popular: 0, // 热销商品
          firstOrderOnly: false,
          canBuy: true,
        }, 
      ],
    }
  },
  props: {
    currentSpu: {
      type: Object,
      default: () => { }
    },
    shrink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isReadOnly(value) {
      return (value) => value === 0;
    },
    currentSkuList() {
      return this.skuList;
    },
    plansStripClass() {
      return [
        'plans-strip w-full flex flex-row items-center gap-[6px] overflow-x-auto overscroll-x-contain pb-[8px]',
        this.isPlansOverflowing ? 'justify-start' : 'justify-center'
      ];
    },
  },
  created() {
    this.handGetPackages() // 获取套餐
  },
  mounted() {
    window.addEventListener('resize', this.updatePlansOverflow);
    this.$nextTick(this.updatePlansOverflow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updatePlansOverflow);
  },
  methods: {
    clickBuyPlan: function (sku, duration) {
      let that = this;
      let item = {
        type: 1,
        id: sku.id,
        title: sku.desc,
        salePrice: sku.salePrice,
        price: sku.price,
        flow: sku.flow,
        give: sku.give,
        days: duration,
      }
      that.$emit('buy-now', item)
    },

    // 获取套餐
    async handGetPackages() {
      let that = this;
      
      that.Loading = true;
      await getPackages({type: 1}).then(res => {
        // await new Promise(resolve => setTimeout(resolve, 3000));

        let data = []
        let packages = res.data[1];

        for (let ccc = 0; ccc < packages.length; ccc++) {
          if (packages[ccc].type == "1") {
            data.push(packages[ccc])
          }
        }

        function func(a, b) {
            return b.weight - a.weight;
        }
        data.sort(func);

        let planList = []
        for (let a in data) {        
          let sku = data[a]
          let plan = {
            id: sku.id,
            desc: sku.display_title,
            salePrice: parseFloat(sku.sale_price), // 销售价格
            price: parseFloat(sku.price), // 原价格
            discountRatio: sku.discount_ratio ? sku.discount_ratio : 0,  // 折扣率%
            duration: parseInt(sku.days), // 周（7天）、月（30天）、季（90天）
            flow: sku.flow,   // MB
            give: sku.give ? sku.give: 0,      // 赠送流量
            popular: sku.popular == 1, // 热销商品
            firstOrderOnly: sku.first_order_only == 1,
            canBuy: sku.can_buy !== false && sku.can_buy !== 0,
          };

          planList.push(plan);
        }

        that.skuList = planList.slice(0, 8);
        that.$nextTick(that.updatePlansOverflow);
      }).catch(e => {
        // this.$message.error(e.message ?? e.msg ?? "request plans error");
      }).finally(e => {
        this.Loading = false;
      });
    },
    updatePlansOverflow() {
      let strip = this.$refs.plansStrip;
      if (!strip) {
        return;
      }

      this.isPlansOverflowing = strip.scrollWidth > strip.clientWidth + 1;
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .plans-strip > div > .group {
    margin-left: 0;
    margin-right: 0;
  }

  .el-loading-mask {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-loading-spinner {
    margin: 0;
    width: fit-content;
  }
}

.plans-strip {
  scrollbar-width: thin;
}

@media (max-width: 1024px) {
  .residential-packages {
    align-items: flex-start;
  }

}
</style>
